import { OpReturnData, TokenSendRequest, } from "../wallet/model.js";
import { FeePaidByEnum } from "../wallet/enum.js";
import { DUST_UTXO_THRESHOLD } from "../constant.js";
export function checkFeeForDust(value) {
    if (value < DUST_UTXO_THRESHOLD) {
        throw Error("Fee strategy would result in dust output");
    }
}
export function checkSatsAvailable(sendRequestArray, fee) {
    let amountAvailable = sendRequestArray.reduce(function (sum, r) {
        return sum + (r.value - DUST_UTXO_THRESHOLD);
    }, 0n);
    if (amountAvailable < fee) {
        throw Error("Insufficient funds for transaction given fee");
    }
}
export function checkForNonStandardSendRequest(output) {
    if (output instanceof TokenSendRequest) {
        throw Error("Cannot specify fee to be paid by TokenSendRequest");
    }
    if (output instanceof OpReturnData) {
        throw Error("Cannot specify fee to be paid by OpReturnData");
    }
    return output;
}
export function sortSendRequests(sendRequestArray) {
    return sendRequestArray.sort((a, b) => Number(a.value - b.value));
}
function distributeFees(requests, fee) {
    checkSatsAvailable(requests, fee);
    for (let r = 0; r < requests.length; r++) {
        if (fee > 0) {
            checkForNonStandardSendRequest(requests[r]);
            let perRequestFee = fee / BigInt(requests.length - r);
            perRequestFee += fee % BigInt(requests.length - r);
            if (requests[r].value - perRequestFee < DUST_UTXO_THRESHOLD) {
                fee -= requests[r].value;
                requests[r].value = 0n;
            }
            else {
                fee -= perRequestFee;
                requests[r].value -= perRequestFee;
            }
        }
    }
    return requests.filter((r) => r.value >= DUST_UTXO_THRESHOLD);
}
function firstPays(requests, fee) {
    let payer = requests.shift();
    payer = checkForNonStandardSendRequest(payer);
    payer.value = payer.value - fee;
    checkFeeForDust(payer.value);
    requests.unshift(payer);
    return requests;
}
function lastPays(requests, fee) {
    let payer = requests.pop();
    payer = checkForNonStandardSendRequest(payer);
    payer.value = payer.value - fee;
    checkFeeForDust(payer.value);
    requests.push(payer);
    return requests;
}
function anyPays(requests, fee) {
    for (let r of requests) {
        checkForNonStandardSendRequest(r);
    }
    requests = sortSendRequests(requests);
    requests = distributeFees(requests, fee);
    return requests;
}
function changeThenFallback(requests, fee, change, fallbackFn) {
    if (BigInt(fee) > change) {
        let outstandingFee = BigInt(fee) - change;
        requests = fallbackFn(requests, outstandingFee);
    }
    return requests;
}
export function allocateFee(requests, fee, feePaidBy, change) {
    if (requests.length > 0) {
        switch (feePaidBy) {
            case FeePaidByEnum.change:
                // handled by default
                break;
            case FeePaidByEnum.changeThenFirst:
                requests = changeThenFallback(requests, fee, change, firstPays);
                break;
            case FeePaidByEnum.changeThenLast:
                requests = changeThenFallback(requests, fee, change, lastPays);
                break;
            case FeePaidByEnum.changeThenAny:
                requests = changeThenFallback(requests, fee, change, anyPays);
                break;
            case FeePaidByEnum.first:
                requests = firstPays(requests, fee);
                break;
            case FeePaidByEnum.last:
                requests = lastPays(requests, fee);
                break;
            case FeePaidByEnum.any:
                requests = anyPays(requests, fee);
                break;
            default:
                throw Error("FeePaidBy option not recognized");
        }
        return requests;
    }
    else {
        throw Error("Attempted to specify feePaidBy on zero length SendRequest");
    }
}
//# sourceMappingURL=allocateFee.js.map